import { NgModule } from '@angular/core';
import { TrackSubmitDirective } from './track-submit.directive';

@NgModule({
  declarations: [TrackSubmitDirective],
  exports: [TrackSubmitDirective],
})
export class TrackSubmitModule {}
